/** The slice of `DataTransfer` a paste needs to decide about attachments. */
export interface ClipboardLike {
  getData: (format: string) => string;
  files: ArrayLike<File>;
}

/**
 * Clipboard screenshots arrive named "image.png" (or unnamed), so a second
 * paste would render an indistinguishable chip. Stamp the generic ones.
 */
const namePastedFile = (file: File, index: number): File => {
  if (file.name && !/^image\.\w+$/i.test(file.name)) return file;
  const ext = file.type.split("/")[1] ?? "png";
  const suffix = index > 0 ? `-${index}` : "";
  return new File([file], `pasted-image-${Date.now()}${suffix}.${ext}`, {
    type: file.type,
  });
};

/**
 * Files a paste should attach; empty means "let the browser paste normally".
 * A clipboard carrying text/plain is a text paste even when it also ships an
 * image — rich-text copies routinely do, and swallowing those would break
 * ordinary pasting. Type/size/count validation belongs to `addAttachment`.
 */
export const pastedAttachments = (data: ClipboardLike): File[] => {
  if (data.getData("text/plain")) return [];
  return Array.from(data.files).map(namePastedFile);
};
